import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './maintenance.module.scss';
import { PUBLIC_PATH } from '../../../config/routes-config';

const SUPPORT_PHONE = '17801';

export const MaintenanceComponent: React.FC = () => {
  const { t } = useTranslation();

  const startPhoneCall = () => {
    window.location.href = 'tel:17801';
  };

  return (
    <div className={styles['maintenance']}>
      <section className={styles['maintenance__media']} aria-hidden="true">
        <img
          className={styles['maintenance__media__image']}
          src={`${PUBLIC_PATH}/assets/pngs/birdnest-reception.png`}
          alt=""
        />
        <div className={styles['maintenance__media__wash']} />
      </section>

      <main className={styles['maintenance__main']}>
        <img
          className={styles['maintenance__main__logo']}
          src={`${PUBLIC_PATH}/assets/pngs/birdnest-logo.png`}
          alt="BirdNest"
        />

        <div className={styles['maintenance__main__content']}>
          <div className={styles['maintenance__main__marker']} role="status">
            <span className={styles['maintenance__main__marker__dot']} />
            {t('SHARED.MAINTENANCE.MARKER')}
          </div>

          <h1 className={styles['maintenance__main__title']}>{t('SHARED.MAINTENANCE.TITLE')}</h1>

          <p className={styles['maintenance__main__lead']}>{t('SHARED.MAINTENANCE.DESCRIPTION')}</p>

          <dl className={styles['maintenance__main__ledger']}>
            <div className={styles['maintenance__main__ledger__row']}>
              <dt>{t('SHARED.MAINTENANCE.GUEST_ISSUE')}</dt>
              <dd>
                <button
                  type="button"
                  className={styles['maintenance__main__ledger__row__contact']}
                  onClick={startPhoneCall}
                >
                  {SUPPORT_PHONE}
                </button>
                {` ${t('SHARED.MAINTENANCE.HOURS')}`}
              </dd>
            </div>
          </dl>

          <div className={styles['maintenance__main__actions']}>
            <button
              type="button"
              className={styles['maintenance__main__actions__primary']}
              onClick={() => window.location.reload()}
            >
              {t('SHARED.MAINTENANCE.RELOAD')}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MaintenanceComponent;
